import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as NspActions from './../actions/nsp.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { NspService } from '../../services/nsp.service';

@Injectable()
export class NspEffects {
  nspProductsPack$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NspActions.GET_NSP_PRODUCTS_IN_PACK),
      mergeMap((action: NspActions.GetNspProductsInPack) =>
        this.nspService.getNspProductsInPack(action.payload).pipe(
          map(
            (entity: IEntity<any>) =>
              new NspActions.GetNspProductsInPackSuccess(entity.value),
          ),
          catchError((error: IEntity<TechnicalError>) =>
            of(
              new NspActions.GetNspProductsInPackFailed(
                error.errorData as TechnicalError,
              ),
            ),
          ),
        ),
      ),
    );
  });

  nspStandaloneProducts$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NspActions.GET_NSP_STANDALONE_PRODUCTS),
      mergeMap((action: NspActions.GetNspStandaloneProducts) =>
        this.nspService.getNspStandaloneProducts(action.payload).pipe(
          map(
            (entity: IEntity<any>) =>
              new NspActions.GetNspStandaloneProductsSuccess(entity.value),
          ),
          catchError((error: IEntity<TechnicalError>) =>
            of(
              new NspActions.GetNspStandaloneProductsFailed(
                error.errorData as TechnicalError,
              ),
            ),
          ),
        ),
      ),
    );
  });

  nspStatisticsProducts$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NspActions.GET_NSP_STATISTICS_PRODUCTS),
      mergeMap(() =>
        this.nspService.getNspStatisticsProducts().pipe(
          map(
            (entity: IEntity<any>) =>
              new NspActions.GetNspStatisticsProductsSuccess(entity.value),
          ),
          catchError((error: IEntity<TechnicalError>) =>
            of(
              new NspActions.GetNspStatisticsProductsFailed(
                error.errorData as TechnicalError,
              ),
            ),
          ),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private nspService: NspService,
  ) {}
}
